import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromConfig from '../reducers/config.reducer';

export const selectConfigState = createFeatureSelector<fromConfig.State>(
  fromConfig.configFeatureKey
);

export const getConfig = createSelector(
  selectConfigState,
  (state) => state.theme
);

export const getWorkFlowStates = createSelector(
  selectConfigState,
  (state) => state.amStatus
);
